
import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';

import { LayoutComposer, Page, H3, H2 } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import css from './AboutUsPage.module.css';

import Photo from './images/photo.png';
import Flowers from './images/flowers-2.svg'

const AboutUsPage = () => {
  const layoutAreas = `
    topbar
    main
    footer
  `;

  const intl = useIntl();

  return (
    <Page
      className={css.root}
      title={intl.formatMessage({ id: "AboutUsPage.pageTitle" })}
      scrollingDisabled={false}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {({ Topbar, Main, Footer }) => (
          <>
            <Topbar as="header" className={css.topbar}>
              <TopbarContainer />
            </Topbar>
            <Main as="main" className={css.main}>
              <div className={css.content}>
                <H3 className={css.heading}>
                  <FormattedMessage id="AboutUsPage.heading" />
                </H3>
                <H2 className={css.mainTitle}>
                  <FormattedMessage id="AboutUsPage.mainTitle" />
                </H2>
                <p className={css.info}>
                  <FormattedMessage id="AboutUsPage.info" />
                </p>
                <section className={css.section}>
                  <div className={css.imageContainer}>
                    <img src={Photo} className={css.photo} />
                    <img src={Flowers} className={css.icon} />
                  </div>
                  <div className={css.bio}>
                    <H2 className={css.title}>
                      <FormattedMessage id="AboutUsPage.title" />
                    </H2>
                    <p className={css.text}>
                      <FormattedMessage id="AboutUsPage.text" />
                    </p>
                  </div>
                </section>
              </div>
            </Main>
            <Footer>
              <FooterContainer />
            </Footer>
          </>
        )}
      </LayoutComposer>
    </Page>
  );
};

export default AboutUsPage;
